const roleOptions = ["Agent/Rep", "Coach", "Manager/Supervisor", "Other"];

export { roleOptions };
